module.exports = __webpack_public_path__ + "static/img/logo2.8e11b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/logo2.png
// module id = xsfR
// module chunks = 3